import type { Prereq } from '../api.js';

export default function PrereqBlock({ prereqs }: { prereqs: Prereq[] }) {
  if (prereqs.length === 0) return null;
  return (
    <div className="section prereq-block">
      <h3>Prereqs — do these first</h3>
      {prereqs.map((p) => (
        <div key={p.id} style={{ marginBottom: 12 }}>
          <div style={{ fontWeight: 600, marginBottom: 4 }}>{p.title}</div>
          <ol style={{ margin: '0 0 4px 18px', padding: 0 }}>
            {p.steps.map((s, i) => (
              <li key={i} className="code">{s}</li>
            ))}
          </ol>
          {p.env_vars && p.env_vars.length > 0 && (
            <div className="kv">
              <strong>env:</strong>
              <span className="code">{p.env_vars.join(', ')}</span>
            </div>
          )}
          {p.paste_into && (
            <div className="kv">
              <strong>paste into:</strong>
              <span className="code">{p.paste_into}</span>
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
